import { ADMIN_DASHBOARD } from 'constants/routes';
import { FilterOutlined } from '@ant-design/icons';
import logo from 'images/logo-full.png';
import * as ROUTE from 'constants/routes';
import React, { useRef, useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import UserAvatar from 'views/account/components/UserAvatar';
import FiltersToggle from './FiltersToggle';
import SearchBar from './SearchBar';
import LanguageSelector from './LanguageSelector';
import MobileAdminNavigation from './MobileAdminNavigation';
import useWindowSize from '../../hooks/useWindowSize';

const AdminNavigation = () => {
  const { t } = useTranslation();
  const navbar = useRef(null);
  const [isMounted, setMounted] = useState(false);
  const [width] = useWindowSize();
  const { isAuthenticating, profile } = useSelector((state) => ({
    isAuthenticating: state.app.isAuthenticating,
    profile: state.profile
  }));
  const { pathname } = useLocation();

  const store = useSelector((state) => ({
    user: state.auth,
    isAuthenticating: state.app.isAuthenticating
  }));

  useEffect(() => {
    if (navbar.current && store.user?.role === 'ADMIN') setMounted(true);
  }, [store.user]);

  const onClickLink = (e) => {
    if (store.isAuthenticating) e.preventDefault();
  };

  if (!store.user || store.user?.role !== 'ADMIN') {
    return null;
  }

  if (isMounted && width <= 928) {
    return (
      <MobileAdminNavigation
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...store}
        pathname={pathname}
      />
    );
  }

  return (
    <nav className="navigation navigation-admin" ref={navbar}>
      <div className="logo">
        <Link onClick={onClickLink} to={ROUTE.HOME}>
          <img alt="Uilpi" src={logo} />
        </Link>
      </div>
      <ul className="navigation-menu-main">
        <li>
          <NavLink
            activeClassName="navigation-menu-active"
            exact
            to={ROUTE.HOME}
          >
            HOME
          </NavLink>
        </li>
        <li>
          <NavLink
            activeClassName="navigation-menu-active"
            exact
            to={ADMIN_DASHBOARD}
          >
            {t('menuAdmin')}
          </NavLink>
        </li>
      </ul>
      <ul className="navigation-menu">
        <li className="navigation-menu-item">
          <LanguageSelector />
        </li>
        <li className="navigation-menu-item">
          {pathname === ROUTE.SHOP && (
            <FiltersToggle>
              <button className="button-muted button-small" type="button">
                {t('menuFilters')} &nbsp;
                <FilterOutlined />
              </button>
            </FiltersToggle>
          )}
        </li>
        <li className="navigation-menu-item">
          <SearchBar />
        </li>
        <li className="navigation-menu-item">
          <UserAvatar isAuthenticating={isAuthenticating} profile={profile} />
        </li>
      </ul>
    </nav>
  );
};

export default AdminNavigation;
